var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"friendly-link mt-20"},[_c('block-head',{attrs:{"title":"友情链接","subtitle":"/ 同行相链，让专业更有力量","icon":"link","hid-more-btn":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }